export default __webpack_public_path__ + "static/media/school-of-mysteries.502bc31c.png";